import React, {useState, useEffect, useRef} from "react"
import IconButton from "../IconButton"
import styles from "./ActionMenu.module.css"

import { createPortal } from "react-dom";

const ActionMenu = ({ actions = [], iconHasBorder=false, iconHasShadow=true }) => {
    const menuRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [coords, setCoords] = useState(null);

    const buttonRef = useRef(null);

    useEffect(() => {
        if (menuOpen && menuRef.current) {
            menuRef.current.focus();
        }
    }, [menuOpen]);

    const openMenu = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const menuWidth = 200;  // approximate width of your menu
            const menuHeight = actions.length * 40; // approximate height per item
    
            let left = rect.left;
            let top = rect.bottom;
    
            // adjust if menu would go off the right edge
            if (left + menuWidth > window.innerWidth) {
                left = window.innerWidth - menuWidth - 8; // 8px margin
            }
    
            // adjust if menu would go off the bottom edge
            if (top + menuHeight > window.innerHeight) {
                top = rect.top - menuHeight;
            }
    
            setCoords({ top, left });
        }
        setMenuOpen(true);
    };

    return (
        <div className={styles.container} ref={buttonRef}>
            <IconButton 
                icon="more-vert"
                onPress={openMenu}
                hasShadow={iconHasShadow}
            />
            {menuOpen && actions.length > 0 &&
                createPortal(
                    <div
                        tabIndex="0"
                        ref={menuRef}
                        style={{ 
                            position: "fixed", 
                            top: coords?.top, 
                            left: coords?.left, 
                            zIndex: 9999 
                        }}
                        className={styles.menu}
                        onBlur={() => setMenuOpen(false)}
                    >
                        {actions.map((action, i) => (
                            <MenuItem 
                                key={`${action.name}${i}`}
                                name={action.name} 
                                onClick={action.onClick}
                                onClose={() => setMenuOpen(false)}
                            />
                        ))}
                    </div>,
                    document.body
                )
            }
        </div>
    )
};

const MenuItem = ({name="", onClick=()=>{}, onClose=()=>{}}) => {
    const handleClick = () => {
        onClick();
        onClose();
    }
    return <div className={styles.menuItem} onClick={handleClick}>{name}</div>
}

export default ActionMenu